import { useCallback, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { ProjectsReportAPI } from 'api/projects-report';
import { Filter } from 'components/molecules/filters/types';
import { DateRange } from 'components/organisms/projects-report/common/range-picker/types';
import { ProjectsReport } from 'components/organisms/projects-report/types';
import { FieldFilter } from 'components/organisms/tasks/filters';
import { Empty, Loaded, Loading } from 'stores/core';

export const useProjectsReport = (
  range: DateRange,
  { criteria, type }: Filter,
  isInitialized: boolean,
): ProjectsReport => {
  const [projectsReport, setProjectsReport] = useState<ProjectsReport>(
    Loading(),
  );

  const validFilters = useMemo(
    () => criteria.filter(FieldFilter.isValid),
    [criteria],
  );

  const getProjectReportsData = useCallback(
    () =>
      ProjectsReportAPI.getReports(range, validFilters, type)
        .then((records) =>
          records.length > 0
            ? setProjectsReport(Loaded(records))
            : setProjectsReport(Empty()),
        )
        .catch(() => {}),
    [range, type, validFilters],
  );

  const response = useQuery(
    ['project-reports', { validFilters, range }],
    getProjectReportsData,
  );

  useDeepCompareEffect(() => {
    if (!isInitialized) {
      return;
    }
    setProjectsReport(Loading());
    response.refetch();
  }, [range, type, validFilters, isInitialized]);

  return projectsReport;
};
